module.exports = __webpack_public_path__ + "img/QR_Code_example.7e46d3e5.png";